import React from 'react'
import Contact from '../Components/contact/Contact'

const ContactPage = () => {
  return (
    <Contact />
  )
}

export default ContactPage